import React, { createContext, useContext, useMemo } from 'react';
import { Originator } from 'types';

export type OriginatorContextType = {
  originator: Originator | undefined;
  setOriginator?: React.Dispatch<React.SetStateAction<Originator | undefined>>;
};

const OriginatorContext = createContext<OriginatorContextType>({
  setOriginator: () => {},
  originator: undefined,
});

export const OriginatorContextProvider: React.FC<{
  originator?: Originator;
}> = ({ originator, children }) => {
  //const [originator, setOriginator] = useState<Originator | undefined>();
  const morg = useMemo(() => originator, [originator]);

  return (
    <OriginatorContext.Provider value={{ originator: morg }}>
      {children}
    </OriginatorContext.Provider>
  );
};
export const useOriginatorContext = () => useContext(OriginatorContext);
